import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const authToken = localStorage.getItem("authToken");

  return isLoggedIn && authToken ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
